// extracted by mini-css-extract-plugin
module.exports = {"description":"KioskFoodDescription_description__3D9Ld"};